import {z} from "zod";
import {createContext} from "react";
import {makeAutoObservable} from "mobx";

export const SignUpFirstSchema = z
  .object({
    name: z.string().min(1, "Обязательное поле"),
    login: z
      .string()
      .min(1, "Обязательное поле")
      .regex(
        /^[a-zA-Z0-9_]+$/,
        "Логин может содержать только латинские буквы, цифры и подчёркивания",
      ),
    email: z.email("Неверный формат email").min(1, "Обязательное поле"),
    password: z
      .string()
      .min(6, "Пароль должен быть не менее 6 символов")
      .min(1, "Обязательное поле"),
    passwordRepeat: z.string().min(1, "Обязательное поле"),
  })
  .refine((data) => data.password === data.passwordRepeat, {
    path: ["passwordRepeat"],
    error: "Пароли должны совпадать",
  });

export const SignUpSecondSchema = z.object({
  type: z.string().min(1, "Обязательное поле"),
  phone: z.string().min(18, "Введите полный номер телефона"),
  agree: z.boolean().refine((value) => value === true, {
    message: "Вы должны согласиться с условиями",
  }),
});

export type SignUpFirstData = z.infer<typeof SignUpFirstSchema>;
export type SignUpSecondData = z.infer<typeof SignUpSecondSchema>;

export class SignUpState {
  constructor() {
    makeAutoObservable(this);
  }

  step: "first" | "second" = "first";

  goToNext = () => {
    if (this.step === "first") {
      this.step = "second";
    }
  };

  goToPrevious = () => {
    if (this.step === "second") {
      this.step = "first";
    }
  };

  firstStepData: SignUpFirstData = {
    name: "",
    login: "",
    email: "",
    password: "",
    passwordRepeat: "",
  };

  setFirstStepData = (data: SignUpFirstData) => {
    this.firstStepData = data;
  };

  secondStepData: SignUpSecondData = {
    type: "",
    phone: "",
    agree: false,
  };

  setSecondStepData = (data: SignUpSecondData) => {
    this.secondStepData = data;
  };

  clearStepsData = () => {
    this.firstStepData = {
      name: "",
      login: "",
      email: "",
      password: "",
      passwordRepeat: "",
    };
    this.secondStepData = {
      type: "",
      phone: "",
      agree: false,
    };
  };
}

export const SignUpStateContext = createContext(new SignUpState());
